/**
 * @generated SignedSource<<55e6de1c7f73eb8d09fc6d63bbe1f4fc>>
 * @relayHash 00ec51509c7f9205b96335f3f528f44c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1a51b2d304474560c09e407081f51fc4b05663b28035ca2d9bbbfef11e39048e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JsmWorkItemIssueDetailsQuery } from './JsmWorkItemIssueDetailsQuery.graphql';

const node: PreloadableConcreteRequest<JsmWorkItemIssueDetailsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1a51b2d304474560c09e407081f51fc4b05663b28035ca2d9bbbfef11e39048e",
    "metadata": {},
    "name": "JsmWorkItemIssueDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
